import { createSlice } from '@reduxjs/toolkit';

interface INodePosition {
  name: string;
  bottom: number;
  height: number;
  left: number;
  right: number;
  top: number;
  width: number;
  x: number;
  y: number;
}

interface TreeGraphSliceState {
  nodePositions: INodePosition[];
}

const initialState: TreeGraphSliceState = {
  nodePositions: [], // 陣列順序代表節點流向順序
};

const treeGraphSlice = createSlice({
  name: 'treeGraphSlice',
  initialState,
  reducers: {
    setNodePositions: (state, action) => {
      state.nodePositions = action.payload;
    },
  },
});

export const { setNodePositions } = treeGraphSlice.actions;
export default treeGraphSlice.reducer;
